import { render, staticRenderFns } from "./ErrorMessageVideoContainer.vue?vue&type=template&id=2546bc5b&scoped=true&"
import script from "./ErrorMessageVideoContainer.vue?vue&type=script&lang=js&"
export * from "./ErrorMessageVideoContainer.vue?vue&type=script&lang=js&"
import style0 from "./ErrorMessageVideoContainer.vue?vue&type=style&index=0&id=2546bc5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2546bc5b",
  null
  
)

export default component.exports